/* colorMapper.ts */

/* Constants */
import { TreatmentLabels } from "src/shared/constants/labels/TreatmentLabels";

export const SANKEY_COLOR_MAPPING: Record<string, string> =
  {
    // Treatments
    [TreatmentLabels.OTHER]: "#00b1d3",
    [TreatmentLabels.ARA_C]: "#0095ae",
    [TreatmentLabels.R_MTX]: "#dbdb8d",
    [TreatmentLabels.R_CHOP]: "#f9a53f",
    [TreatmentLabels.R_BENDA]: "#67bdab",
    [TreatmentLabels.R_MINI_CHOP]: "#f87843",
    [TreatmentLabels.R_POLA_CHP]: "#d62728",
    [TreatmentLabels.CYCLOPHOSPHAMIDE_MONOTHERAPY]:
      "#d3b100",
    [TreatmentLabels.ACALABRUTINIB_MONOTHERAPY]: "#1f77b4",
    [TreatmentLabels.VENETOCLAX_MONOTHERAPY]: "#17bebb",
    [TreatmentLabels.FCR]: "#a55a82",
    [TreatmentLabels.BENDAMUSTINE_AND_OBINUTUZUMAB]:
      "#008dd3",
    [TreatmentLabels.BENDAMUSTINE_MONOTHERAPY]: "#d62728",
    [TreatmentLabels.CHLORAMBULIC_AND_OBINUTUZMAB]:
      "#00a4ae",
    [TreatmentLabels.CHLORAMBULIC_MONOTHERAPY]: "#00aeaa",
    [TreatmentLabels.FLUDARABINE_AND_RITUXIMAB]: "#dbc88d",
    [TreatmentLabels.IBRUTINIB_AND_VENETOCLAX]: "#f9963f",
    [TreatmentLabels.IBRUTINIB_MONOTHERAPY]: "#f9873f",
    [TreatmentLabels.IDELALISIB_AND_RITUXIMAB]: "#d65227",
    [TreatmentLabels.IDELAISIB_MONOTHERAPY]: "#e38566",
    [TreatmentLabels.OBINUTUZUMAB_MONOTHERAPY]: "#b27378",
    [TreatmentLabels.RITUXIMAB_MONOTHERAPY]: "#d38c00",
    [TreatmentLabels.VENETOCLAX_AND_OBINUTUZUMAB]:
      "#cc8200",
    [TreatmentLabels.ZANUBRUTINIB_MONOTHERAPY]: "#abadd3",
    [TreatmentLabels.ONGOING]: "#afbed2",
    [TreatmentLabels.NOT_REACHED]: "#afbed2",
    [TreatmentLabels.DECEASED]: "#afbed2",
    // Watch and Wait is not an active treatment, so it sits on the grey scale
    // rather than taking a vivid hashed colour. A neutral mid-grey, distinct
    // from the no-value greys (#8a8f98 / #c2c6cc) and the blue-grey end states.
    [TreatmentLabels.WATCH_AND_WAIT]: "#a8adb5",

    // Medications
    [TreatmentLabels.BORTEZOMIB]: "#008dd3",
    [TreatmentLabels.ADALIMUMAB]: "#0095ae",
    [TreatmentLabels.AZATHIOPRINE]: "#dbdb8d",
    [TreatmentLabels.BUDESONIDE]: "#f9a53f",
    [TreatmentLabels.CORTISONE]: "#67bdab",
    [TreatmentLabels.GOLIMUMAB]: "#f87843",
    [TreatmentLabels.INFLIXIMAB]: "#d62728",
    [TreatmentLabels.MESALAMINE]: "#d3b100",
    [TreatmentLabels.PREDNISOLONE]: "#1f77b4",
    [TreatmentLabels.USTEKINUMAB]: "#17bebb",
    [TreatmentLabels.VEDOLIZUMAB]: "#a55a82",
  };
